export function loadScript(scriptUrl: string, options?: any) {
  return createScript(scriptUrl, options);
}

export function loadScriptsInSequence(scriptUrls: Array<string>) {
  return queue(scriptUrls.map((url) => [createScript, url]));
}

/**
 * @deprecated
 * @replaced with loadChatwoot
 */
export function loadLiveChat() {
  console.log('::start init LiveChat');
  const script = document.createElement('script');
  script.innerHTML = `
  window.__lc = window.__lc || {};
  window.__lc.license = 13897164;
  ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
  `;

  document.body.appendChild(script);
  console.log('::end init LiveChat');
}

export function loadChatwoot() {
  const script = document.createElement('script');
  script.innerHTML = `
  window.chatwootSettings = {"position":"right","type":"standard","launcherTitle":"Chat with us"};
  (function(d,t) {
    var BASE_URL="https://contact.hostex.io";
    var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
    g.src=BASE_URL+"/packs/js/sdk.js";
    g.defer = true;
    g.async = true;
    s.parentNode.insertBefore(g,s);
    g.onload=function(){
      console.log('[chatwoot loaded] ...')
      window.chatwootSDK.run({
        websiteToken: 'PSSVrxKisaVndMwPcZQqX2Rt',
        baseUrl: BASE_URL
      })
    };
    window.addEventListener("chatwoot:error", function (e) {
      console.log('chatwoot error: ', e)
    });
    window.addEventListener("chatwoot:ready", function () {
      console.log('[chatwoot ready] ...')
      fetch('/api/customer_service/chat/info')
        .then(res=> {return res.json();})
        .then(res=> {
          console.log(res.data.chatwoot);
          const chatwoot = res.data.chatwoot;
          window.$chatwoot.setUser(chatwoot.uid, chatwoot.user);
          window.$chatwoot.setCustomAttributes(chatwoot.custom_att);
        });
      });
    })(document,"script");
  `;
  document.body.appendChild(script);
}

function createScript(url: string, options = {}): Promise<any> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    // tslint:disable-next-line: forin
    for (const attr in options) {
      script[attr] = options[attr];
    }

    script.onload = function () {
      console.log(`${script.src} loaded ...`);
      resolve(true);
    };
    script.onerror = function () {
      reject(true);
    };
    document.head.appendChild(script);
  });
}
function queue(list: Array<any>): Promise<boolean> {
  let p = Promise.resolve(true);
  list.forEach((promise) => {
    if (Array.isArray(promise)) {
      p = p.then(() => {
        return promise[0].apply(promise, promise.slice(1));
      });
    } else {
      p = p.then(promise);
    }
  });
  return p;
}

//#region created at 4.0.2
// export function loadScripts(urls, parallel) {
//   // 创建一个 Promise 数组
//   const promises = [];

//   // 遍历所有要加载的 JS 文件的 URL
//   urls.forEach((url) => {
//     // 创建一个 Promise 对象，用于加载单个 JS 文件
//     const promise = new Promise((resolve, reject) => {
//       console.log('start create : ', url);
//       const script = document.createElement('script');
//       script.type = 'text/javascript';
//       script.src = url;

//       script.onload = () => {
//         console.log(`${script.src} loaded ...`);
//         resolve(null);
//       };
//       script.onerror = reject;

//       // 将脚本添加到文档中
//       document.head.appendChild(script);
//     });

//     // 将每个加载脚本的 Promise 添加到 Promise 数组中
//     promises.push(promise);
//   });

//   // 返回一个 Promise，用于在所有脚本加载完成后进行处理
//   return parallel
//     ? Promise.all(promises)
//     : promises.reduce((chain, promise) => chain.then(() => promise), Promise.resolve());
// }

export function loadScriptsSequentially(scriptUrls, callback) {
  if (scriptUrls.length === 0) {
    callback();
    return;
  }

  const scriptUrl = scriptUrls.shift();
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.onload = function () {
    console.log('script loaded: ', scriptUrl);
    loadScriptsSequentially(scriptUrls, callback);
  };
  document.head.appendChild(script);
}

//#endregion
